exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-left {\n  text-align: left;\n}\n\n.margin-right-slim {\n  margin-right: 6px;\n}\n\n.form-control.ng-valid[required] {\n  border-left: 5px solid #42A948;\n}\n\n.form-control.ng-invalid.ng-dirty {\n  border-left: 5px solid #a94442;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/constructs/constructs-details/constructs-details.component.css
// module id = ../../../../../src/app/modules/constructs/constructs-details/constructs-details.component.css
// module chunks = main